// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__ElFRu","inputDescription":"styles_inputDescription__3Wu9g"};